// "Build me a slip" around the picks already on it: the slip after a /slip/build response and
// the short notes that say what changed. Pure, so tests can run it without the store.

// The display snapshot for a leg from a priced response leg.
export function snapshotFromPriced(leg) {
  return {
    id: leg.id,
    label: leg.label,
    match: leg.match,
    match_id: leg.match_id,
    kickoff: leg.kickoff,
    side: leg.side || null,
  };
}

// The built slip in the server's order (kept picks first), reusing the snapshots of picks that
// were already on it.
export function mergeBuilt(current, builtLegs) {
  const byId = {};
  (current || []).forEach((leg) => {
    byId[leg.id] = leg;
  });
  return (builtLegs || []).map((leg) =>
    byId[leg.id] && byId[leg.id].label ? byId[leg.id] : snapshotFromPriced(leg),
  );
}

// One line per pick the build had to take off, then a line if it had nothing to add.
export function buildNotes(current, builtLegs, removed) {
  const before = new Set((current || []).map((leg) => leg.id));
  const notes = (removed || []).map((r) => {
    const mine = (current || []).find((leg) => leg.id === r.id);
    const label = (mine && mine.label) || r.label || "A pick";
    const match = mine && mine.match ? ` (${mine.match})` : "";
    return `Took off ${label}${match}: ${r.reason}.`;
  });
  const added = (builtLegs || []).filter((leg) => !before.has(leg.id)).length;
  if (before.size && builtLegs && builtLegs.length && !added) {
    notes.push("Your picks already reach that price, so nothing was added.");
  }
  return notes;
}
